import { compose } from 'ramda';

const { xslt } = window.qd;

const parseXml = window.jQuery.parseXML;

const transformSource = (template, functions) => {
    // String -> CompiledTransform
    const compileTransform = (xsltFile) => {
        const doc = parseXml(xsltFile);

        return xslt.compile(doc);
    };

    // (CompiledTransform, DOMNode) -> DOMNode
    const executeTransform = (node) => (transform) =>
        transform.transform(node, { functions });

    // (String, DOMNode) -> Promise[DOMNode]
    const compileAndExecute = (xsltFile, node) =>
        compose(executeTransform(node), compileTransform)(xsltFile);

    // (String, DOMNode) -> Promise[DOMNode]
    const transform = async (xsltFileName, node) => {
        const transformFile = await template.getTemplateFileAsync(xsltFileName);

        return compileAndExecute(transformFile, node);
    };

    // (String, DOMNode) -> Promise[DOMNode]
    const transformWithPreProcessedView = async (xsltFileName, dom) => {
        const { Main } = await template.getViewDefinitionAsync(xsltFileName);

        return compileAndExecute(Main, dom);
    };

    return {
        transform,
        transformWithPreProcessedView,
    };
};

export default transformSource;
